import TicketsContainer from "./TicketsContainer";

export default TicketsContainer;
